/* oxlint-disable typescript/no-explicit-any */
/* oxlint-disable react/no-danger */
import * as React from 'react';
import { Store } from 'redux';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';

import { ApplicationContext } from '../../../../shared/utils/applicationContext';
import { IAppState, IContext } from '../../../../shared/store';

import type { JSX } from 'react';

interface IDependencies {
  app: JSX.Element;
  store: Store<IAppState>;
  rootElement: HTMLElement;
  context: IContext;
  /** Разметка от SSR, снятая до гидрации. */
  ssrMarkup: string;
}

export function renderReactApp({ store, app, rootElement, context, ssrMarkup }: IDependencies) {
  const { logger } = context;

  /**
   * Заглушка корневого boundary: возвращает в DOM серверную разметку, иначе ErrorLogComponent
   * нарисует пустой <span> и краулер увидит пустую страницу. Интерактивность теряется,
   * контент и ссылки остаются. display: contents — чтобы обёртка не ломала раскладку корня.
   */
  const ssrFallback = <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: ssrMarkup }} />;

  ReactDOM.hydrateRoot(
    rootElement,
    <ApplicationContext.Provider value={context}>
      <Provider store={store as any}>
        <ErrorLogComponent logger={logger} errorStub={ssrFallback}>
          {app}
        </ErrorLogComponent>
      </Provider>
    </ApplicationContext.Provider>,
    {
      /**
       * Ошибку не поймал ни один boundary — React размонтировал корень. Возвращаем серверную
       * разметку руками, иначе страница останется пустой.
       */
      onUncaughtError: (error, errorInfo) => {
        logger.error(error as Error, {
          domain: 'react.uncaughtError',
          componentStack: errorInfo.componentStack,
        });

        rootElement.innerHTML = ssrMarkup;
      },
    },
  );
}
